import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';
import {Icon} from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import GeneralButton from '../../../../components/Common/AllButton/AllButton';
import goTo from '../../../../actions/goTo';
import { createTagPayload } from '../../../../../utils/tagHelpers';
import { useTranslation, withTranslation } from 'react-i18next';

const styles = theme => ({
    container: {
        marginTop: 10,
        marginRight: 10,
        width: 206,
        maxWidth: 206,
        height: 348,
        position: 'relative',
        borderRadius: 4,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
        '&:last-child': {
            marginRight: 0
        },  
    },
    img: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        width: 206,
        height: 204,
    },
    icon: {
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 74
    },
    content: {
        height: 144,
        background: 'rgba(0,0,0,0.2)',
        flexDirection: 'row',
        position: 'absolute',
        width: '100%'
    },
    title: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
            textDecorationColor: 'ffffff'
        },
        height: 22,
        marginTop: 16,
        marginBottom: 6,
        paddingRight: 10,
        paddingLeft: 10,
        fontFamily: 'Rubik',
        fontSize: 18,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#fff',
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: 'nowrap',
    },
    subtitle: {
        height: 21,
        opacity: 0.6,
        marginTop: 6,
        paddingRight: 10,
        paddingLeft: 10,
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#fff',
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: 'nowrap',
    },
    subsribe: {
        marginTop: 16,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    subsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: 'transparent',
        border: 'solid 2px #fff',
        color: '#fff',
        '&:hover': {
            background: '#fff',
            color: '#3b3187',
        },
    },
    subsribeButtomText: {
        marginTop: 2,
        fontSize: 14,
        lineHeight: 2,
        letterSpacing: 1.5,
    },
    unsubsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: '#fff',
        border: 'solid 2px #fff',
        color: '#3b3187',
        '&:hover': {
            background: 'transparent',
            color: '#fff',
        },
    },
});

const checkIfSubscribed = (tag, userData) => {    
    if(userData.subscribedTags && userData.subscribedTags.length && tag){
        return userData.subscribedTags.some(t => (t.tag || "").toLowerCase() === tag.toLowerCase())
    }
    return false
}

const DataType = (props) => {
    const {classes, dataType, dispatch, userData, subscribe} = props
    const {tag, icon} = dataType
    const isSubsribed = checkIfSubscribed(tag, userData)
    const [t] =  useTranslation('inputTypes')

    const onClickGeneral = () => {
        if(isSubsribed) {
            openDataTypeView()
            return
        }
        subscribe(createTagPayload(tag, icon, 'user_tag'), openDataTypeView)
    }
    const renderSubscribeButton = () => {
        const title = isSubsribed ? t('VIEW') : t('SUBSCRIBE')
        const containerStyle = isSubsribed ? classes.unsubsribeButtomContainer : classes.subsribeButtomContainer
        return <GeneralButton onClick={onClickGeneral} containerStyle={containerStyle} textStyle={classes.subsribeButtomText} title={title} />
    }
    const openDataTypeView = () => {
        goTo('#' + dataType.tag, dispatch)();
    }
        return (
            <div data-intrcm-id="DataType_ln4vx4q2" style={{backgroundColor: dataType.backgroundColor}} className={classes.container}>
                <div data-intrcm-id="DataType_joics86r" style={{backgroundColor: dataType.backgroundColor}} className={classes.img} >
                    <Icon color="default" className={classes.icon}>{icon}</Icon>
                </div>
                <div data-intrcm-id="DataType_eqyi0gs6" className={classes.content}>
                    <div data-intrcm-id="DataType_11y51r0h" onClick={openDataTypeView} className={classes.title}>{t(dataType.title)}</div>
                    <div data-intrcm-id="DataType_lhri0xis" className={classes.subtitle}>{t(dataType.description)}</div>
                    <div data-intrcm-id="DataType_9j4iq890" className={classes.subsribe}>{renderSubscribeButton()}</div>
                </div>
          </div>
        )
}

const mapStateToProps = (state) => ({
    userData: state.userData
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps))(DataType);
